class ResolutionSingleton {
  static instance: ResolutionSingleton;
  private _supportedResolutions: string[] = [];
  private _supportedIntradayMultipliers: string[] = [];
  constructor() {
    if (!ResolutionSingleton.instance) {
      const supportedResolutionsInMinutes = Array.from(
        { length: 299 },
        (_, index) => (index + 1).toString(),
      );

      const supportedResolutionsInHours = Array.from(
        { length: 5 },
        (_, index) => ((index + 1) * 60).toString(),
      );

      const supportedResolutionsInDays = Array.from(
        { length: 365 },
        (_, index) => `${(index + 1).toString()}D`,
      );

      const supportedResolutionsInWeeks = Array.from(
        { length: 52 },
        (_, index) => `${(index + 1).toString()}W`,
      );

      const supportedResolutionsInMonths = Array.from(
        { length: 12 },
        (_, index) => `${(index + 1).toString()}M`,
      );

      const supportedIntradayMultipliers = Array.from(
        { length: 1380 },
        (_, index) => (index + 1).toString(),
      );

      this._supportedResolutions = [
        ...supportedResolutionsInMinutes,
        ...supportedResolutionsInHours,
        ...supportedResolutionsInDays,
        ...supportedResolutionsInWeeks,
        ...supportedResolutionsInMonths,
      ];
      this._supportedIntradayMultipliers = [...supportedIntradayMultipliers];
      ResolutionSingleton.instance = this;
    }
    return ResolutionSingleton.instance;
  }

  get supportedResolutions() {
    return this._supportedResolutions;
  }

  set supportedResolutions(newResolutions) {
    if (Array.isArray(newResolutions)) {
      this._supportedResolutions = newResolutions;
    } else {
      throw new Error('New resolutions should be an array.');
    }
  }

  get supportedIntradayMultipliers() {
    return this._supportedIntradayMultipliers;
  }

  set supportedIntradayMultipliers(newResolutions) {
    if (Array.isArray(newResolutions)) {
      this._supportedIntradayMultipliers = newResolutions;
    } else {
      throw new Error('New intraday multipliers should be an array.');
    }
  }
}

export default new ResolutionSingleton();
